// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '../../DataCache';
import { BrandingToolLinkGenerator } from './Branding/BrandingToolLinkGenerator';
import { BaseExtLink } from './BaseExtLink';
import { ResourcesManager } from '../../properties/ResourcesManager';
export class AutochartistExtLink extends BaseExtLink {
    constructor() {
        super(...arguments);
        this.ssoDNS = '';
        this.ssoEndPoint = '';
        this.brokerID = '';
        this.secretKey = '';
        this.accountType = '';
    }
    update(brandingTool, extLinkMessage) {
        var _a, _b, _c, _d, _e;
        super.update(brandingTool, extLinkMessage);
        if (brandingTool) {
            this.ssoDNS = (_a = brandingTool.ssoDNS) !== null && _a !== void 0 ? _a : this.ssoDNS;
            this.ssoEndPoint = (_b = brandingTool.ssoEndPoint) !== null && _b !== void 0 ? _b : this.ssoEndPoint;
            this.brokerID = (_c = brandingTool.brokerId) !== null && _c !== void 0 ? _c : this.brokerID;
            this.secretKey = (_d = brandingTool.secretKey) !== null && _d !== void 0 ? _d : this.secretKey;
            this.accountType = (_e = brandingTool.accountType) !== null && _e !== void 0 ? _e : this.accountType;
        }
    }
    generateUrl() {
        var _a;
        const brandingTC = DataCache.ExternalLinksCache.getAutochartistExtLink();
        const userID = DataCache.getUserID();
        const autochartistUrl = BrandingToolLinkGenerator.generateAutochartistLink(brandingTC, userID ? `${userID}` : '', ResourcesManager.extLinkLocaleName());
        if (autochartistUrl) {
            this.url = autochartistUrl;
            (_a = this.updateValue) === null || _a === void 0 ? void 0 : _a.call(this, autochartistUrl);
        }
    }
}
